let isListenerAdded = false;
function addScrollClickListener() {
  if (isListenerAdded) return;

  const reviewLink = document.querySelector('.yotpo-display-wrapper .standalone-bottomline .text-m[tabindex="-1"]');
  const targetDiv = document.getElementById('yotpo-reviews-main-widget');

  if (reviewLink && targetDiv) {
    reviewLink.setAttribute('tabindex', '0');
    reviewLink.setAttribute('role', 'button');
    if (!targetDiv.hasAttribute('tabindex')) targetDiv.setAttribute('tabindex', '-1');

    const activate = function () {
      targetDiv.scrollIntoView({ behavior: 'smooth' });
      targetDiv.focus({ preventScroll: true });
    };

    reviewLink.addEventListener('click', activate);
    reviewLink.addEventListener('keydown', function (event) {
      if (event.key !== 'Enter' && event.key !== ' ') return;
      event.preventDefault();
      activate();
    });

    isListenerAdded = true;
  }
}

document.addEventListener('DOMContentLoaded', function () {
  const observer = new MutationObserver(function (mutationsList, observer) {
    for (let mutation of mutationsList) {
      if (mutation.type === 'childList') {
        addScrollClickListener();
      }
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });
});
